import { salesModes } from 'commons/filters';
import { STATUSES } from 'commons/statuses';
import { getFinalDate, getInitialDate } from 'helpers/date';
import { filter as lodashFilter, sortBy } from 'lodash';
import {
  DashboardFilterForm,
  DashboardSearchForm,
  DashboardSearchType,
  FormOption,
} from 'types';

const DELIVERED_LABEL = 'Entregue';

export const storeShipmentsStatuses = lodashFilter(STATUSES, {
  storeFilter: true,
});

const deliveredCustomValue = storeShipmentsStatuses
  .filter(({ label }) => label === DELIVERED_LABEL)
  .map(({ value }) => value)
  .join(',');
const deliveredCustomStatus = {
  label: DELIVERED_LABEL,
  value: deliveredCustomValue,
};

const deliveryFailCustomStatus = {
  label: 'Falha na entrega/Falha na coleta',
  value: 'CLARIFY_DELIVERY_FAIL',
};

const formattedShipmentsStatuses = storeShipmentsStatuses
  .filter(
    ({ label, value }) =>
      label !== DELIVERED_LABEL &&
      value !== 'CLARIFY_DELIVERY_FAIL' &&
      value !== 'COLLECT_FAIL'
  )
  .map(({ label, value }) => ({ label, value }));

export const shipmentsStatuses: FormOption[] = sortBy(
  [
    ...formattedShipmentsStatuses,
    deliveredCustomStatus,
    deliveryFailCustomStatus,
  ],
  ['label']
);

const DEFAULT_DASHBOARD_SEARCH: DashboardSearchForm = {
  searchType: DashboardSearchType.Codes,
  codes: '',
  email: '',
  cpf: '',
  ean: '',
  filterDate: '',
};

export function getDefaultDashboardSearch(): DashboardSearchForm {
  return {
    ...DEFAULT_DASHBOARD_SEARCH,
    filterDate: new Date().toDateString(),
  };
}

const DEFAULT_DASHBOARD_FILTER: DashboardFilterForm = {
  startDate: getInitialDate(),
  endDate: getFinalDate(),
  salesModes: salesModes.map(({ value }) => value).sort(),
  statuses: storeShipmentsStatuses
    .filter(({ initialStoreFilter }) => initialStoreFilter)
    .map(({ value }) => value)
    .sort(),
  deliveryModes: [],
  filterDate: '',
};

export function getDefaultDashboardFilter(): DashboardFilterForm {
  return {
    ...DEFAULT_DASHBOARD_FILTER,
    startDate: getInitialDate(),
    endDate: getFinalDate(),
    filterDate: new Date().toDateString(),
  };
}
